module.exports = __webpack_public_path__ + "img/company3.fc0bc4e1.png";